/**
 * WS5 ships mid-month behind a flag. The Vite flag hides the Log slot;
 * the API's ENABLE_CHAPTER_CLAIMS is the real gate on writes.
 */
export function isClaimsUiEnabled(flag = import.meta.env.VITE_ENABLE_CHAPTER_CLAIMS) {
  return flag === 'true';
}

export function claimLabel(chapter) {
  if (!chapter) return '';
  const book = chapter.book || '';
  const number = chapter.chapter;
  return number == null ? book : `${book} ${number}`;
}
